import Mustache from "mustache";
import Search, { ViewFilterType, SearchInitConfig, SearchClientConfig } from "../search";
import { MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu';
import Utility from '../../classes/utility';
import MediaCentreRender from "../customRenders/media-centre-render";

// media center templates
const mediaCentreNoResultsTemplate = require('../../../templates/components/search/partials/media-centre-no-results').default;
const mediaCentreItemTemplate = require('../../../templates/components/search/partials/media-centre-item-search--list').default;

// parent templates
const searchParentTemplate = require('/src/templates/components/search/media-centre/search-parent-tpl').default;
const itemParentTemplate = require('/src/templates/components/search/media-centre/item-parent-tpl').default;

class MediaCenterSearch extends Search {
    private landingSearchElement: HTMLElement;
    private landingSearchBox: HTMLElement;
    private landingSearchResults: HTMLElement;

    constructor(landingSearchElement: HTMLElement, clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
        this.landingSearchElement = landingSearchElement;
        this.landingSearchResults = document.querySelector(`.${landingSearchElement.dataset.id}-results`);
        this.renderParent();
        this.initConfigOverride();
    }

    private initConfigOverride() {
        this.initConfig = {
            searchBoxId: this.landingSearchBox.id,
            resultContainerId: "landing-search-hits",
            queryName: "mcq",
            allowEmptyQuery: true,
            showOnLoad: true,
            activeTemplate: "list",
            textboxPlaceholder: "Search experts...",
            templates: {
                list: mediaCentreItemTemplate,
                empty: mediaCentreNoResultsTemplate
            },
            customRender: MediaCentreRender.customRender
        };
    }

    private renderParent() {
        let self = this;
        self.landingSearchElement.innerHTML = Mustache.render(searchParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchResults.innerHTML = Mustache.render(itemParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        this.landingSearchBox = self.landingSearchElement.querySelector(".landing-search-box");
    }

    private onLoadFacets(facets: Array<any>) {
        let self = this;
        facets.forEach(facet => {
            self.addFacet({
                field: facet.key,
                value: facet.value,
            });
        });
    }

    private onLoadViewFilters() {
        let self = this;
        self.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${self.landingSearchElement.dataset.id}-clearFilters`,
            clearExcludedAttributes: ['type']
        });
        let expertLabel = function(item: MenuItem)
        {
            item.label = item.label.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3');
            return item;
        }
        self.addViewFilter({
            elementId: `${self.landingSearchElement.dataset.id}-filterExperts`,
            cssClasses: {
                select: "filter"
            },
            modFn: expertLabel
        });
    }

    private onLoadSearch() {
        let self = this;
        // get the algolia search box
        if (self.landingSearchBox) {
            // init algolia
            self.init();
        }
    }

    private onLoadViewUpdates() {
        let self = this;
        let landingSearchId = this.landingSearchElement.dataset.id;
        const hitsContainer: HTMLElement = document.querySelector(`.${landingSearchId}-results`); //.media-centre-search
        this.customSearch = function () {
            let clearFiltersBtn = document.getElementById(`${landingSearchId}-clearFilters`) as HTMLDivElement;
            let mediaExpertsFilter = document.getElementById(`${landingSearchId}-filterExperts`) as HTMLDivElement;
            
            // let searchInputField = document.getElementsByClassName("ais-SearchBox-input")[1] as HTMLInputElement | null;
            if (clearFiltersBtn) {
                // display clear filters text
                clearFiltersBtn.classList.remove("d-none");
                clearFiltersBtn.classList.add("d-inline-block");
            } else {
                clearFiltersBtn.classList.add("d-none");
                clearFiltersBtn.classList.remove("d-inline-block");
                self.setSearchBoxValue("");
            }
            // hide results on first load
            let firstLoad = hitsContainer.dataset.firstLoad;
            if (firstLoad == "true")
            {
                hitsContainer.classList.add('d-none');
                hitsContainer.dataset.firstLoad = "false";
            } else {
                if (hitsContainer.dataset.firstLoad == "false")
                {
                    let selectField = mediaExpertsFilter.querySelector('select');
                    if (self.getSearchBoxValue() && self.getSearchBoxValue() != "")
                    {
                        hitsContainer.classList.remove('d-none');
                    }
                    if (selectField)
                    {
                        if (selectField.value != "")
                        {
                            hitsContainer.classList.remove('d-none');
                        }
                    }
                }
            }
        }
    }

    override onLoad(facets: Array<any>) {
        this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }

    public init() {
        super.init();
        let query = Utility.getUrlParameter(this.initConfig.queryName);
        if (query) {
            this.setSearchBoxValue(query);
        }

        let filterExpert = Utility.getUrlParameter("filter-categoryExpert");
        if (filterExpert) {
            this.filterByTag(filterExpert);
        }
    }

    filterByOption() {
        let landingSearchId = this.landingSearchElement.dataset.id;
        let option = document.getElementById(`${landingSearchId}-filter`) as HTMLSelectElement;
        this.filterByTag(option.options[option.selectedIndex].text);
    }

    filterByTag(tag: string) {
        var filterName = "";
        if (tag.indexOf(' ') >= 0) {
            filterName = tag.charAt(0).toLowerCase() + tag.substring(1).replace(' ', '');
        } else {
            filterName = tag;
        }

        let landingSearchId = this.landingSearchElement.dataset.id;
        var si = setInterval(() => {
            let mediaExpertsFilter = document.getElementById(`${landingSearchId}-filterExperts`) as HTMLDivElement;
            if (mediaExpertsFilter) {
                let selectField = mediaExpertsFilter.querySelector('select');
                if (selectField)
                {
                    clearInterval(si);
                    if (selectField.querySelector(`option[value=${filterName}]`))
                    {
                        selectField.value = filterName;
                        selectField.dispatchEvent(new Event('change'));
                    }
                }
            }
        }, 1000);
        
        // Utility.setUrlParameter('filter-categoryExpert', filterName);
        // this.filter('recordObj.categoryExpert', filterName);
    }
}
export default MediaCenterSearch;